import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import { AuthEventIds } from '../../../EventIds.es.js';
import { decodeBase64JWTToken } from '../../../utils/utils.es.js';

/* eslint-disable  @typescript-eslint/naming-convention */

/* eslint-enable  @typescript-eslint/naming-convention */

/*
 * LogOnBehalfManager
 *
 * Manage the log on behalf token once loaded from the cookies
 * BrowserPlatformProvider is responsible for handling the token in the cookie
 */
var LogOnBehalfManager = /*#__PURE__*/function () {
  function LogOnBehalfManager(_ref) {
    var platformProvider = _ref.platformProvider,
      log = _ref.log;
    _classCallCheck(this, LogOnBehalfManager);
    this.platformProvider = void 0;
    this.log = void 0;
    this.token = void 0;
    this.tokenExpiration = void 0;
    this.tokenInfo = void 0;
    this.platformProvider = platformProvider;
    this.log = log;
    this.log.getInstance('LogOnBehalfManager');

    // It's important to store the token and not read the cookie each time otherwise if the Cookie Expires before the token does...
    // the app will automatically switch to not logged on behalf without fully reloading
    this.token = this.platformProvider.getLogOnBehalfValue();
    if (this.token) {
      var _decodedTokenInfo$htt;
      var decodedTokenInfo = decodeBase64JWTToken(this.token);
      this.tokenExpiration = (decodedTokenInfo === null || decodedTokenInfo === void 0 ? void 0 : decodedTokenInfo.exp) * 1000; // convert to milliseconds
      this.tokenInfo = {
        username: (_decodedTokenInfo$htt = decodedTokenInfo === null || decodedTokenInfo === void 0 ? void 0 : decodedTokenInfo['https://api.landr.com/user_name']) !== null && _decodedTokenInfo$htt !== void 0 ? _decodedTokenInfo$htt : '',
        tokenExpiration: new Date(this.tokenExpiration)
      };
    }
  }

  /**
   * Retrieve the log on behalf token.
   */
  _createClass(LogOnBehalfManager, [{
    key: "getLogOnBehalfAccessToken",
    value: function getLogOnBehalfAccessToken() {
      if (this.token) {
        if (this.getIsExpired()) {
          this.clearLogOnBehalfSession();
          this.log.warn('LogOnBehalf Token expired, reloading the page to clear the session.', AuthEventIds.GetAccessTokenOnBehalfError);
          this.platformProvider.reload();
          return Promise.reject(new Error('LogOnBehalf Token expired'));
        }
        return Promise.resolve(this.token);
      }
      this.log.error('No LogOnBehalf Token available. this should not happen, please check first if there is a LOB session available', AuthEventIds.GetAccessTokenOnBehalfError);
      return Promise.reject(new Error('No LogOnBehalf token available'));
    }
  }, {
    key: "getLogOnBehalfInfo",
    value: function getLogOnBehalfInfo() {
      if (this.token) {
        return {
          isLoggedOnBehalf: !this.getIsExpired(),
          extraInfo: this.tokenInfo
        };
      }
      return {
        isLoggedOnBehalf: false
      };
    }
  }, {
    key: "clearLogOnBehalfSession",
    value: function clearLogOnBehalfSession() {
      // try to Clear the cookie in case Cookie expiration is different from the token expiration
      this.platformProvider.clearLogOnBehalfValue();

      // clear all the token stored information
      this.token = undefined;
      this.tokenExpiration = undefined;
      this.tokenInfo = undefined;
    }
  }, {
    key: "getIsExpired",
    value: function getIsExpired() {
      if (!this.tokenExpiration) {
        return true;
      }
      var exp = this.tokenExpiration;
      var now = new Date().getTime();
      return now >= exp;
    }
  }]);
  return LogOnBehalfManager;
}();

export { LogOnBehalfManager };
